import { Dispatch, SetStateAction, useCallback } from 'react';
import {
  Dismissed,
  EarthDayFilter,
  PromoBanners
} from '@/srp/PromoBanner/constants';
import { BannerDismissed } from '@/srp/PromoBanner/hooks/useHandleShowLogic';
import { COOKIES } from '~/constants/srp';
import tagId from '~/constants/srp/TagId';
import { useNativeSupportsDismissBanner } from '~/context/common/NativeContext';
import { useAppliedFiltersContext } from '~/context/srp/AppliedFiltersContext';
import { setBannerDismissedCookie } from '../utils';

export default function useHandleBannerClicks(
  banner: PromoBanners,
  setLocalDismissed: Dispatch<SetStateAction<BannerDismissed>>
) {
  const nativeSupportsDismissedBanners = useNativeSupportsDismissBanner();
  const { setAppliedFilters, updateListFilter } = useAppliedFiltersContext();

  const handleShopAllClick = useCallback(() => {
    switch (banner) {
      case PromoBanners.PriceDrop:
        setLocalDismissed(prevState => ({
          ...prevState,
          isPriceDropDismissed: Dismissed.Banner
        }));
        updateListFilter({
          filterKey: 'tagIds',
          value: tagId.PriceDrop.toString()
        });
        break;
      case PromoBanners.Ev:
        setLocalDismissed(prevState => ({
          ...prevState,
          isEVDismissed: Dismissed.Banner
        }));
        updateListFilter({
          filterKey: 'tagIds',
          value: tagId.EVCredit.toString()
        });
        break;
      case PromoBanners.Earth:
        setLocalDismissed(prevState => ({
          ...prevState,
          isEarthDismissed: Dismissed.Banner
        }));
        setAppliedFilters(EarthDayFilter);
    }
  }, [banner, setAppliedFilters, setLocalDismissed, updateListFilter]);

  const handleCloseClick = useCallback(() => {
    switch (banner) {
      case PromoBanners.PriceDrop:
        setBannerDismissedCookie(
          PromoBanners.PriceDrop,
          COOKIES.dismissedNewPriceBanner,
          !nativeSupportsDismissedBanners
        );
        setLocalDismissed(prevState => ({
          ...prevState,
          isPriceDropDismissed: Dismissed.Banner
        }));
        break;
      case PromoBanners.Ev:
        setBannerDismissedCookie(
          PromoBanners.Ev,
          COOKIES.dismissedEVBanner,
          !nativeSupportsDismissedBanners
        );
        setLocalDismissed(prevState => ({
          ...prevState,
          isEVDismissed: Dismissed.Banner
        }));
        break;
      case PromoBanners.Earth:
        setBannerDismissedCookie(
          PromoBanners.Earth,
          COOKIES.dismissedEarthDayBanner,
          !nativeSupportsDismissedBanners
        );
        setLocalDismissed(prevState => ({
          ...prevState,
          isEarthDismissed: Dismissed.Banner
        }));
    }
  }, [banner, nativeSupportsDismissedBanners, setLocalDismissed]);

  return { handleShopAllClick, handleCloseClick };
}
